 
const GRANTED = 'granted';
const DENIED = 'denied';

export const isNotificationSupported = () => {
  return 'Notification' in window;
};

export const isNotificationGranted = () => {
  if (isNotificationSupported()) return Notification.permission === GRANTED;
  return false;
};
export const isNotificationDenied = () => {
  if (isNotificationSupported()) return Notification.permission === DENIED;
  return false;
};

export const askNotificationPermission = () => {
  if (
    isNotificationSupported() &&
    !isNotificationGranted() &&
    !isNotificationDenied()
  )
    Notification.requestPermission();
};

const createNotification = (
  title,
  message,
  icon,
  badge,
  image,
  vibrate,
  requireInteraction,
  data,
  { onClick, onClose, onError, onShow }
) => {
  const notification = new Notification(title, {
    body: message,
    icon,
    image,
    badge,
    requireInteraction,
    vibrate,
  });
  if (notification) {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        notification.close();
      }
    });

    notification.addEventListener('click', (event) => {
      event.preventDefault();
      notification.close();
      window.parent.focus();
      if (onClick) {
        onClick(event, data);
      }
    });

    if (onClose) notification.addEventListener('close', onClose);
    if (onError) notification.addEventListener('error', onError);
    if (onShow) notification.addEventListener('show', onShow);
  }
  return notification;
};

export const notify = (
  { title, message, icon, image, badge, vibrate, requireInteraction, data },
  onClick,
  onClose,
  onError,
  onShow
) => {
  if (!isNotificationSupported()) {
    console.log('This browser does not support desktop notification');
    return Promise.reject();
  }
  if (isNotificationGranted()) {
    return Promise.resolve(
      createNotification(
        title,
        message,
        icon,
        badge,
        image,
        vibrate,
        requireInteraction,
        data,
        {
          onClick,
          onClose,
          onError,
          onShow,
        }
      )
    );
  }
  if (!isNotificationDenied()) {
    return Notification.requestPermission().then((permission) => {
      if (permission === GRANTED) {
        return createNotification(
          title,
          message,
          icon,
          badge,
          image,
          vibrate,
          requireInteraction,
          data,
          {
            onClick,
            onClose,
            onError,
            onShow,
          }
        );
      }
      return null;
    });
  }
  return Promise.reject();
};
